module.exports = __webpack_public_path__ + "img/ilus04.f60e2e1f.gif";